import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconReturns = t0 => {
  const $ = _c(11);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? "#585858" : t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M12.064 17.08L12 9.946a2.7 2.7 0 011.403-2.382l11.32-6.225a2.76 2.76 0 012.613-.023l11.218 5.92A2.695 2.695 0 0140 9.62v12.56c0 .988-.544 1.895-1.419 2.37L27.29 30.668a2.755 2.755 0 01-2.644-.012l-11.148-6.162a2.691 2.691 0 01-1.4-2.35l-.005-1.73" />;
    t3 = <path d="M12 9l13.5 7L39 9.163M25.5 16v15M8 11l-6 5.5L8 22" />;
    t4 = <path d="M4 16.5h13" strokeLinecap="square" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== color) {
    t5 = <g stroke={color} strokeWidth={1.5} fill="none" fillRule="evenodd">{t2}{t3}{t4}</g>;
    $[6] = color;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== otherProps || $[9] !== t5) {
    t6 = <svg width={41} height={32} viewBox="0 0 41 32" {...otherProps}>{t5}</svg>;
    $[8] = otherProps;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
IconReturns.propTypes = {
  color: PropTypes.string
};
export default IconReturns;